import React from 'react';
import Axios from 'axios';
import moment from 'moment';
import { withRouter } from "../withRouter";
import { ConnectedUserContext } from '../connectedUser-context';

import Users from './Users';
import AutoSuggestPlayer from '../shared/AutoSuggest/AutoSuggestPlayer';

const autoSuggTheme = {
  container: 'react-autosuggest-std__container',
  input: 'react-autosuggest-std__input',
  inputOpen: 'react-autosuggest-std__input--open',
  inputFocused: 'react-autosuggest-std__input--focused',
  suggestionsContainer: 'react-autosuggest-std__suggestions-container',
  suggestionsContainerOpen: 'react-autosuggest-std__suggestions-container--open',
  suggestionsList: 'react-autosuggest-std__suggestions-list',
  suggestion: 'react-autosuggest-std__suggestion',
  suggestionHighlighted: 'react-autosuggest-std__suggestion--highlighted',
};

class Profile extends React.Component {
  static contextType = ConnectedUserContext;

  constructor(props) {
    super(props);
    this.state = {
      user: null,            // copie locale
      players: [],
      loading: true,
      newUser: false,
    };
    this.handleUserChange = this.handleUserChange.bind(this);
    this.handlePlayerChange = this.handlePlayerChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    const { connectedUser } = this.context;
    if (connectedUser?.user) this.loadPlayersAndInit();
  }

  componentDidUpdate() {
    const cu = this.context.connectedUser?.user;
    const had = this.prevHadUser;
    if (!had && cu) this.loadPlayersAndInit();
    if (had && !cu) this.props.navigate("/", { replace: true });
    this.prevHadUser = !!cu;
  }

  loadPlayersAndInit() {
    const cu = this.context.connectedUser?.user;
    if (!cu) return;

    // console.log("PROFILE - loadPlayersAndInit connectedUser", cu)
    Axios.get('/api/players')
      .then(res => {
        const players = res.data;
        const exists = !!cu._id;

        let formUser;
        if (exists) {
          formUser = { ...cu }; // copie du user existant
        } else {
          formUser = {
            auth0_user_id: cu.auth0_user_id || '',
            auth0_name: cu.auth0_name || '',
            email: cu.email || '',
            name: '',
            picture: cu.picture || '',
            playerId: '',
            tel: '',
            streetaddress: '',
            addresslevel2: '',
            addresslevel1: '',
            postalcode: '',
            country: ''
          };
        }

        this.setState({
          players,
          user: formUser,
          newUser: !exists,
          loading: false,
        });
      })
      .catch(err => console.error('players fetch error:', err));
  }

  handleUserChange(e) {
    const { id, value } = e.target;
    this.setState(prev => ({
      user: { ...prev.user, [id]: value }
    }));
  }

  handlePlayerChange(dataValue) {
    if (this.state.user?.playerId) {
      alert("Ce profil est déjà associé et ne peut être modifié, contactez Statelo.");
      return;
    }

    this.setState(prev => ({
      user: { ...prev.user, playerId: dataValue }
    }));
  }

  handleSubmit(e) {
    e.preventDefault();
    const { user } = this.state;
    if (!user?.playerId) {
      alert("Vous devez spécifier un Profil Statistique valide.");
      return;
    }

    // console.log("PROFILE - user on handleSubmit", user)
    const auth0Id = user.auth0_user_id || '';
    const userData = { ...user };
    delete userData._id;

    Axios.post(`/api/users/modifyUserData/${auth0Id}`, { userData })
      .then(res => {
        const { wasInserted, upsertedId } = res.data;
        if (wasInserted) Users.setConnection(upsertedId, () => {});

        // console.log("handleSubmit done")
        this.context.refreshConnectedUser({ sub: auth0Id }, 'profile', () => {

          // console.log("back from refreshConnectedUser")
          this.props.navigate('/userAccount', { replace: true }); 
        });
      })
      .catch(err => console.error('Erreur lors de la sauvegarde du profil', err));
  }

  displaySpinner() {
    return (
      <div className="sk-three-bounce">
        <div className="sk-child sk-bounce1"></div>
        <div className="sk-child sk-bounce2"></div>
        <div className="sk-child sk-bounce3"></div>
      </div>
    );
  }

  render() {
    return (
      <div className="animated fadeIn">
        {this.displayModule()}
      </div>
    );
  }

  displayModule() {
    const { connectedUser } = this.context;
    const { user, newUser, loading } = this.state;

    if (!connectedUser) {
      return (
        <div>
          <p>Vous devez être connecté pour visualiser votre profil.<br/>
          Cliquez sur <b>Se connecter</b> dans la barre de gauche.</p>
        </div>
      );
    }

    if (loading || !user) return this.displaySpinner();

    return (
      <div>
        <div className="row">
          <div className="col-md-6">
            <h5>{newUser ? 'Nouvel utilisateur : Création de votre profil' : 'Modifier votre profil'}</h5>
            <h5>{connectedUser.user.name}</h5>
          </div>
        </div>
        <hr/>
        <div className="row">
          <div className="col-md-8">
            <form className="form-horizontal" onSubmit={this.handleSubmit}>
              <div className="form-group">
                <h5>Informations Utilisateur</h5>
              </div>
              {this.displayData(user)}
              <button type="submit" className="btn btn-primary">Sauvegarder</button>
            </form>
          </div>
        </div>
      </div>
    );
  }

  displayData(user) {
    const playerLocked = !!user.playerId;
    return (
      <div>
        {[
          ['name', 'Nom', 'text', 'Prénom et Nom', 'name'],
          ['streetaddress', 'Adresse', 'text', 'No et rue', 'street-address'],
          ['addresslevel2', 'Ville', 'text', '', 'address-level2'],
          ['addresslevel1', 'Province / État', 'text', '', 'address-level1'],
          ['postalcode', 'Code postal', 'text', 'A0A 0A0', 'postal-code'],
          ['country', 'Pays', 'text', '', 'country'],
          ['email', 'Courriel', 'email', '', 'email'],
          ['tel', 'Téléphone', 'tel', '000-000-0000', 'tel']
        ].map(([id, label, type, placeholder, autoComplete]) => (
          <div key={id} className="form-group">
            <div className="row">
              <div className="col-md-8">
                <label htmlFor={id} className="labelSmallMarginBottom">{label}</label>
                <input
                  type={type}
                  className="form-control"
                  id={id}
                  placeholder={placeholder}
                  value={user[id] || ''}
                  onChange={this.handleUserChange}
                  required
                  autoComplete={autoComplete}
                />
              </div>
            </div>
          </div>
        ))}

        <div className="form-group">
          <div className="row">
            <div className="col-md-8">
              <label htmlFor="playerId" className="labelSmallMarginBottom">PROFIL STATISTIQUE</label>
              <p>(Entrez quelques lettres de votre prénom ou nom pour rechercher votre profil)</p>

              {playerLocked ? (
                <>
                  <input
                    type="text"
                    className="form-control"
                    value={
                      (() => {
                        const p = this.state.players.find(pl => pl._id === user?.playerId);
                        if (!p) return 'Profil déjà associé';
                        return `${p.firstname} ${p.lastname}${p.special ? ' ' + p.special : ''}`;
                      })()
                    }
                    disabled
                  />
                  <small>(Ce profil est verrouillé. Contactez Statelo si une correction est nécessaire.)</small>
                </>
              ) : (
                <>
                  <AutoSuggestPlayer
                    theme={autoSuggTheme}
                    playerId={user.playerId}
                    dataChange={this.handlePlayerChange}
                  />
                  <small>(Vous ne pourrez pas modifier cette sélection par la suite. Contactez Statelo en cas d'erreur.)</small>
                </>
              )}

            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Profile);
